import { render, staticRenderFns } from "./LightCourseBottomResult.vue?vue&type=template&id=f0a40a88&scoped=true&"
import script from "./LightCourseBottomResult.vue?vue&type=script&lang=js&"
export * from "./LightCourseBottomResult.vue?vue&type=script&lang=js&"
import style0 from "./LightCourseBottomResult.vue?vue&type=style&index=0&id=f0a40a88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a40a88",
  null
  
)

export default component.exports